import React from 'react';
import { View } from '@react-pdf/renderer';
import { HeadText, LeadText } from 'components/Pdf/PdfUI';
import { ExternalOrderPdfData, OrderPdfData } from './MyOrdersDetailPdfPage';

export const Header = ({ data }: { data: OrderPdfData | ExternalOrderPdfData }) => (
  <View style={{ display: 'flex', gap: 5 }}>
    <HeadText>{data.text.orderNumber}</HeadText>
    <LeadText>{data.text.date}</LeadText>
  </View>
);
